import { combineEpics } from 'redux-observable';

// EPICS
import authEpics from '../containers/Auth/authEpics';
import contactsEpics from '../containers/Contacts/contactsEpics';
import forgottenPasswordEpics from '../containers/ForgottenPassword/forgottenPasswordEpics';
import freebiesEpics from '../containers/Freebies/freebiesEpics';
import invitationEpics from '../containers/Invitation/invitationEpics';
import linksEpics from '../containers/Links/linksEpics';
import mediaEpics from '../containers/Media/mediaEpics';
import metricsEpics from '../containers/Metrics/metricsEpics';
import newsletterEpics from '../containers/Newsletter/newsletterEpics';
import paymentsEpics from '../containers/Payments/paymentsEpics';
import productsEpics from '../containers/Products/productsEpics';
import projectEpics from '../containers/Project/projectEpics';
import projectsEpics from '../containers/Projects/projectsEpics';
import siteConfigEpics from '../containers/SiteConfig/siteConfigEpics';
import tagsEpics from '../containers/Tags/tagsEpics';
import telemetryEpics from '../containers/Telemetry/telemetryEpics';
import userEpics from '../containers/User/userEpics';
import usersEpics from '../containers/Users/usersEpics';

// SLICES
import authSlice from '../containers/Auth/authSlice';
import contactsSlice from '../containers/Contacts/contactsSlice';
import forgottenPasswordSlice from '../containers/ForgottenPassword/forgottenPasswordSlice';
import freebiesSlice from '../containers/Freebies/freebiesSlice';
import invitationSlice from '../containers/Invitation/invitationSlice';
import linksSlice from '../containers/Links/linksSlice';
import mediaSlice from '../containers/Media/mediaSlice';
import metricsSlice from '../containers/Metrics/metricsSlice';
import newsletterSlice from '../containers/Newsletter/newsletterSlice';
import notificationsSlice from '../containers/Notifications/notificationsSlice';
import paymentsSlice from '../containers/Payments/paymentsSlice';
import productsSlice from '../containers/Products/productsSlice';
import projectSlice from '../containers/Project/projectSlice';
import projectsSlice from '../containers/Projects/projectsSlice';
import siteConfigSlice from '../containers/SiteConfig/siteConfigSlice';
import systemSlice from '../containers/System/systemSlice';
import tagsSlice from '../containers/Tags/tagsSlice';
import telemetrySlice from '../containers/Telemetry/telemetrySlice';
import userSlice from '../containers/User/userSlice';
import usersSlice from '../containers/Users/usersSlice';

const rootEpic = combineEpics(
	...authEpics,
	...contactsEpics,
	...forgottenPasswordEpics,
	...freebiesEpics,
	...invitationEpics,
	...linksEpics,
	...mediaEpics,
	...metricsEpics,
	...newsletterEpics,
	...paymentsEpics,
	...productsEpics,
	...projectEpics,
	...projectsEpics,
	...siteConfigEpics,
	...tagsEpics,
	...telemetryEpics,
	...userEpics,
	...usersEpics
);

const rootReducer = {
	authSlice,
	contactsSlice,
	forgottenPasswordSlice,
	freebiesSlice,
	invitationSlice,
	linksSlice,
	mediaSlice,
	metricsSlice,
	newsletterSlice,
	notificationsSlice,
	paymentsSlice,
	productsSlice,
	projectSlice,
	projectsSlice,
	siteConfigSlice,
	systemSlice,
	tagsSlice,
	telemetrySlice,
	userSlice,
	usersSlice
};

export { rootEpic, rootReducer };
